<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      disable-pagination
      disable-sort
      hide-default-footer
      :headers="headers"
      :items="historico"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.evento != 'Saldo' ? item.data : '' | dataBR }}</td>
            <td>
              <div>{{ item.evento_texto }}</div>
              <template v-if="item.grade">
                <v-chip
                  v-for="(_grade, index) in item.grade"
                  class="mr-2"
                  x-small 
                  color="grey lighten-2"
                  :key="index"
                >{{_grade.descricao}}</v-chip>
              </template>
            </td>
            <td class="text-right">
              <span :style="{color: item.evento == 'Saída' ? 'red' : ''}" >
                {{ item.quantidade | valorBR(0) }}
              </span>

              <!-- <span v-if="item.evento == 'Entrada'">({{ item.balanco }})</span> -->

              <span>
                <v-icon color="green" v-if="item.evento == 'Entrada'" :title="item.evento">mdi-arrow-bottom-left-thick</v-icon>
                <v-icon color="red" v-if="item.evento == 'Saída'" :title="item.evento">mdi-arrow-top-right-thick</v-icon>
              </span>
            </td>
            <td class="text-right">
              <span v-if="item.evento == 'Entrada'">({{ item.balanco }})</span>
              <!-- <span>({{ item.balanco }})</span> -->
            </td>
            <td class="text-right">{{ item.saldo | valorBR(0) }}</td>
            <td class="text-right">{{ item.valor | valorBR }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    historico: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: "Data", value: "data", width: '100px' },
        { text: "Evento", value: "evento_texto" },
        { text: "Quantidade", value: "quantidade", width: '130px', align: "right" },
        { text: "Disponível", value: "balanco", width: '130px', align: "right" },
        { text: "Saldo", value: "saldo", width: '130px', align: "right" },
        { text: "Valor", value: "valor", width: '130px', align: "right"},
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
